// Character scanners shared across class-variable parsing helpers.
// Provides identifier, whitespace, and numeric token checks.

// Skip whitespace from index and return first non-space position.
export function skipWhitespace(input: string, fromIndex: number): number {
  let index = fromIndex
  // Advance while current character is whitespace.
  while (index < input.length && isWhitespace(input[index])) {
    index += 1
  }

  // Return first non-whitespace index.
  return index
}

// Detect identifier start characters.
export function isIdentifierStart(char: string): boolean {
  // Return true for valid identifier start chars.
  return (
    (char >= 'a' && char <= 'z')
    || (char >= 'A' && char <= 'Z')
    || char === '_'
  )
}

// Detect identifier continuation characters.
export function isIdentifierChar(char: string): boolean {
  // Return true for valid identifier continuation chars.
  return isIdentifierStart(char) || (char >= '0' && char <= '9') || char === '-'
}

// Detect property name start characters.
export function isPropertyNameStart(char: string): boolean {
  // Return true for valid property name start chars.
  return isIdentifierStart(char) || char === '-'
}

// Detect property name continuation characters.
export function isPropertyNameChar(char: string): boolean {
  // Return true for valid property name continuation chars.
  return isIdentifierChar(char)
}

// Detect whitespace characters used in scanner logic.
export function isWhitespace(char: string): boolean {
  // Return true for whitespace code points used by source scanner.
  return char === ' ' || char === '\t' || char === '\n' || char === '\r'
}

// Detect whether input string starts with whitespace.
export function startsWithWhitespace(input: string): boolean {
  // Return true when first char is whitespace.
  return input.length > 0 && isWhitespace(input[0])
}

// Detect decimal digits for array index scanning.
export function isDigit(char: string): boolean {
  // Return true for characters 0-9.
  return char >= '0' && char <= '9'
}
